import React from 'react';
import Nav from 'react-bootstrap/Nav';
import { Container } from './styles';

export class Tab {
    key: string = '';
    text: string = '';
}

interface ITabMenuProps {
    tabs: Tab[];
    activeKey: string;
    change?: (key: string) => void;
    backgroundColor?: string;
    activeBackgroundColor?: string;
}

export const TabMenu: React.FC<ITabMenuProps> = ({
    tabs,
    activeKey,
    change,
    backgroundColor,
    activeBackgroundColor
}) => {

    const tabsRender = tabs.map(tab => (
        <Nav.Item key={`tab-${tab.key}`}>
            <Nav.Link onClick={() => change ? change(tab.key) : null} active={activeKey === tab.key}>{tab.text}</Nav.Link>
        </Nav.Item>
    ));

    return (
        <Container backgroundColor={backgroundColor} activeBackgroundColor={activeBackgroundColor}>
            <Nav variant="pills">
                {tabsRender}
            </Nav>
        </Container>
    );
}